<script setup lang="ts">
const { id = 'searchfield' } = defineProps<{
  id?: string
}>()

const emit = defineEmits(['focus'])

const searchIconUrl = `url(${usePublicAssetUrl('/icons/SearchIcon.svg')}`

const model = defineModel({
  default: '',
})
</script>

<template>
  <form class="w-full">
    <slot :id="id" />
    <div class="mt-4 mb-8 flex items-stretch">
      <input
        :id="id"
        v-model="model"
        type="search"
        data-dd-privacy="mask"
        class="w-full rounded-l-[0.75rem] bg-(--ks-input) p-2 text-xl text-green-50 xs:p-4"
        @focus="emit('focus')"
      />
      <button
        data-search-button
        :aria-label="`søk på ${model} i hele nettsiden`"
        class="min-w-16 rounded-r-[0.75rem] bg-white text-[10px] hover:bg-green-35"
        type="submit"
      />
    </div>
  </form>
</template>

<style scoped>
[data-search-button] {
  background-image: v-bind(searchIconUrl);
  background-size: 2.5rem;
  background-repeat: no-repeat;
  background-position: 60%;
}
</style>
